/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LeadAssignmentRole = {
    Owner: 'OWNER',
    Liaison: 'LIAISON'
} as const;
export type LeadAssignmentRole = typeof LeadAssignmentRole[keyof typeof LeadAssignmentRole];


export function LeadAssignmentRoleFromJSON(json: any): LeadAssignmentRole {
    return LeadAssignmentRoleFromJSONTyped(json, false);
}

export function LeadAssignmentRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadAssignmentRole {
    return json as LeadAssignmentRole;
}

export function LeadAssignmentRoleToJSON(value?: LeadAssignmentRole | null): any {
    return value as any;
}

